import React, { useState, useCallback, useEffect } from 'react'
import axios from '~/lib/axios'
import shallowequal from 'shallowequal'
import { CreditCardFormState } from '~/types'
import { addCardApiResponse } from '~/types/api'
import EditArea from './EditArea'
import validate from './validate'
import { useValidateForm } from '~/lib/hooks/validateForm'
import { useBusy } from '~/lib/hooks/busy'
import { useDispatch } from '~/lib/hooks/redux'
import styled from 'styled-components'
import Button from '~/components/atoms/Button'

export const initialFormState: CreditCardFormState = {
  cardNumber: '',
  cvc: ''
}

interface Props {
  type: 'add' | 'edit'
  onChange(): void
  onClose(): void
}

export default function CreditCardForm({ type, onChange, onClose }: Props) {
  const [formState, setFormState] = useState<CreditCardFormState>(initialFormState)
  const [busy, startBusy, endBusy] = useBusy()
  const dispatch = useDispatch()

  const [result, handleChangeFactory] = useValidateForm<CreditCardFormState>(
    formState,
    setFormState,
    validate
  )
  const [edited, setEdited] = useState<boolean>(false)

  // なにか入力したら保存ボタンを押せるようにするためチェック
  useEffect(() => {
    if (!shallowequal(formState, initialFormState)) {
      setEdited(true)
    }
  }, [formState])

  const handleAddCard = useCallback(async () => {
    try {
      startBusy()
      await axios<addCardApiResponse>(
        {
          method: 'post',
          url: '/users/cards',
          data: {
            cardNumber: formState.cardNumber,
            expMonth: formState.expMonth,
            expYear: formState.expYear,
            cvc: formState.cvc
          }
        },
        { dispatch }
      )
      onChange()
    } finally {
      endBusy()
    }
  }, [formState, onChange])

  const handleEditCard = useCallback(async () => {
    try {
      startBusy()
      await axios<addCardApiResponse>(
        {
          method: 'put',
          url: '/users/cards',
          data: {
            cardNumber: formState.cardNumber,
            expMonth: formState.expMonth,
            expYear: formState.expYear,
            cvc: formState.cvc
          }
        },
        { dispatch }
      )
      onChange()
    } finally {
      endBusy()
    }
  }, [formState, onChange])

  const errors = Object.values(result.getErrors())

  return (
    <>
      <EditArea formState={formState} handleChangeFactory={handleChangeFactory} result={result} />
      <ButtonWrapper>
        <Button
          label={'設定する'}
          color='primary'
          onClick={type === 'add' ? handleAddCard : handleEditCard}
          disabled={errors.length > 0 || !edited || busy}
        />
        <Button label='キャンセル' color='cancel' onClick={onClose} disabled={busy} />
      </ButtonWrapper>
    </>
  )
}

const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 16px;
  justify-self: center;
`
